import React, { useEffect, useState, useContext } from "react";
import { Typography, Box, Backdrop, CircularProgress, InputAdornment, TextField, Button, Stack, TableCell, DialogContent, tableCellClasses, styled, IconButton, Dialog,
FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import { Search, InfoOutlined, InsertDriveFileOutlined } from '@mui/icons-material';
import Header from "./Header";
import SorTable from "./sortable";
import { API } from "../conf";
import { Context } from "../App";
import moment from 'moment';
import {theme} from '../App'

export default function JrnDepartement() {
    const { updateConnect } = useContext(Context)
    const editCol = {header: "", sortable: false, row: (row, index)=><StyledTableCell key={index} sx={{minWidth:'80px', maxWidth:'120px'}} >
        <IconButton aria-label="Edit facture/reçu" onClick={()=>get_facture(row)}><InsertDriveFileOutlined fontSize="small"/></IconButton>
        <IconButton aria-label="informations complémentaires" onClick={()=>get_facture(row)}><InfoOutlined fontSize="small"/></IconButton>
    </StyledTableCell>}
    const table = [
        {header: "Date", sortable: true, sortBy:(el)=>new Date(el.date).getTime(), row: (row, index)=><StyledTableCell key={index} align="center" >{moment.utc(row.date).format('DD/MM/YYYY')}</StyledTableCell>},
        {header: "Libellé", sortable: true, sortBy:el=>el.libelle.toLowerCase(), row: (row, index)=><StyledTableCell key={index} sx={{minWidth:'150px', width:'100%'}} align="center">{row.libelle}</StyledTableCell>},
        {header: "Montant", sortable: true, sortBy:el=>el.montant, row: (row, index)=><StyledTableCell key={index} align="right" style={{fontWeight:'bold', color: row.montant>0? theme.palette.valide.main : theme.palette.carmine.main}}>{(row.montant>0?'+':'')+row.montant.toFixed(2)}€</StyledTableCell>},
    ]
    const [loading, setLoad] = useState(true)
    const [min_date, setMin] = useState()
    const [max_date, setMax] = useState()
    const [start_date, setStart] = useState('')
    const [end_date, setEnd] = useState('')
    const [search_input, setSearch] = useState('')
    const [journal, setJournal] = useState()
    const [depmts, setDeptmts] = useState([])
    const [depmt, setDeptmt] = useState('')
    const [logs, setLogs] = useState()
    const [pdf, setPdf] = useState()
    const [showPdf, setShow] = useState(false)

    function get_facture(log) {
        setLoad(true)
        fetch(API.concat(`/eglises/by/${JSON.stringify({isFederation: true})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setPdf(URL.createObjectURL(json))
                    setShow(true);
                }
                setLoad(false)
            }
        })
    }

    function getLogs() {
        setLoad(true)
        const eglise = JSON.parse(sessionStorage.getItem('eglise'))

        fetch(API.concat(`/logs/eglises/${JSON.stringify({action: {$in: ['enregistrement dépense']}, eglise: eglise._id,
            $and: [{when: {$lte: new Date(end_date)}}, { when: {$gte: new Date(start_date)}}]})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    const sorted = await json.map(log=>{log.what = JSON.parse(log.what); return log.what.versements.map(ver=> {ver.date=log.when; return ver})}).sort((a, b) => new Date(a.when).getTime() - new Date(b.when).getTime())
                    setLogs(sorted);
                }
                setLoad(false)
            }
        })
    }

    function get_journal() {
        setLoad(true)
        const eglise = JSON.parse(sessionStorage.getItem('eglise'))
        const depmts_ids = depmts.map(dep=> dep._id)

        fetch(API.concat(`/dons/by/${JSON.stringify({eglise: eglise._id, "offrande_spe_eglise.compte":{$in: depmts_ids}, $and: [{date: {$lte: new Date(end_date).setTime(new Date(end_date).getTime()+24*60*60*1000)}}, { date: {$gte: new Date(start_date)}}]})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async res=>{
            const token = res.headers.get('x-auth-token')
            if(res.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', res.headers.get('x-auth-token'))
                }
                if (res.status === 200) {
                    const dons = await res.json()
                    fetch(API.concat(`/depenses/by/${JSON.stringify({eglise: eglise._id, compte: {$in: depmts_ids}, $and: [{date: {$lte: new Date(end_date).setTime(new Date(end_date).getTime()+24*60*60*1000)}}, { date: {$gte: new Date(start_date)}}]})}`), {
                        method:'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                        }
                    }).then(async response=>{
                        const token = response.headers.get('x-auth-token')
                        if(response.status === 401) {
                            sessionStorage.clear()
                            updateConnect(false)
                        }else {
                            if (token && token !== sessionStorage.getItem('token') && token !== '') {
                                sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                            }
                            if (response.status === 200) {
                                const deps = await response.json()
                                const sorted = deps.map(dep => {return({_id: dep._id, date: dep.date, libelle: dep.libelle, montant: -dep.montant, compte: dep.compte})}).concat(
                                    dons.map(don => don.offrande_spe_eglise.filter(off=>depmts_ids.includes(off.compte)).map(off=>{off._id=don._id; off.date= don.date; off.donateur = don.donateur; off.libelle='Offrande spécifiées'; return off})).flat()
                                ).sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                                setJournal(sorted)
                                setLoad(false)
                            }else setLoad(false)
                        }
                    })
                }else setLoad(false)
            }
        })
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-,.€]/gi,'').toLowerCase()
    }

    function get_searchable(row) {
        return row.libelle+' '+row.montant.toFixed(2)
    }

    useEffect(()=>{
        const eglise = JSON.parse(sessionStorage.getItem('eglise'))

        function get_departments() {
            fetch(API.concat(`/comptes/by/${JSON.stringify({eglise: eglise._id, is_departement: true})}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setDeptmts(json)
                    }
                }
            })
        }
        get_departments()

        function get_dates() {
            fetch(API.concat(`/depenses/${eglise._id}/dates/min_max`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    const depenses = response.status===200 ? await response.json() : []
                    fetch(API.concat(`/dons/${eglise._id}/dates/min_max`), {
                        method:'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                        }
                    }).then(async res=>{
                        const token = res.headers.get('x-auth-token')
                        if(res.status === 401) {
                            sessionStorage.clear()
                            updateConnect(false)
                        }else {
                            if (token && token !== sessionStorage.getItem('token') && token !== '') {
                                sessionStorage.setItem('token', res.headers.get('x-auth-token'))
                            }
                            if (res.status === 200) {
                                const dons = await res.json()
                                if(depenses && dons && Object.keys(depenses).includes("mindate") && Object.keys(depenses).includes("maxdate") && Object.keys(dons).includes("mindate") && Object.keys(dons).includes("maxdate")){
                                    setMin(new Date(new Date(depenses.mindate).getTime()<new Date(dons.mindate).getTime() ? depenses.mindate : dons.mindate))
                                    setMax(new Date(new Date(depenses.maxdate).getTime()>new Date(dons.maxdate).getTime() ? depenses.maxdate : dons.maxdate))
                                    setEnd(moment.utc(new Date(depenses.maxdate).getTime()>new Date(dons.maxdate).getTime() ? depenses.maxdate : dons.maxdate).format('yyyy-MM-DD'))
                                } else {
                                    setMin(new Date(Date.now()).setDate(0))
                                    setMax(new Date()); setEnd(moment.utc(Date.now()).format('yyyy-MM-DD'))
                                }
                            }
                            setLoad(false)
                        }
                    })
                }
            })
        }
        get_dates()
    }, [updateConnect])

    useEffect(()=>{}, [depmts, depmt])

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
    }));     
    
    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Journal des Départements</Typography>
            <Box sx={{paddingX:'20px', marginTop:'30px'}}>
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <Stack direction='row' spacing={2} sx={{alignItems:'center'}}>
                        <Typography fontWeight={600} fontSize={16}>Période:</Typography>
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'100px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de début"
                        type='date'
                        value={start_date}
                        inputProps={min_date&&max_date&&{min: new Date(min_date).toISOString().split("T")[0], max: new Date(max_date).toISOString().split("T")[0]}}
                        onChange={(event)=> {
                            setStart(event.target.value)
                            if (end_date!=='' && (new Date(end_date).getTime() - new Date(event.target.value).getTime()) <= 0) {
                                setEnd('')
                            } 
                        }}
                        />
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'100px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de fin"
                        type="date"
                        value={end_date}
                        inputProps={min_date&&max_date&&{min: new Date(start_date!=='' ? start_date : min_date).toISOString().split("T")[0], max: new Date(max_date).toISOString().split("T")[0]}}
                        onChange={(event)=> {
                            setEnd(event.target.value)
                            if (start_date!=='' && (new Date(event.target.value).getTime() - new Date(start_date).getTime()) <= 0) {
                                setStart('')
                            }
                        }}
                        />
                        <Button variant="contained" disabled={start_date===''||end_date===''} onClick={get_journal}>Appliquer</Button>
                    </Stack>
                    <FormControl sx={{ m: 1, width:'30%', minWidth: '250px' }}>
                        <InputLabel>Département</InputLabel>
                        <Select
                        size="small"
                        sx={{ width:'25%', minWidth:'150px', maxWidth:'500px'}}
                        label="Département"
                        value={depmt}
                        onChange={(e)=>setDeptmt(e.target.value)}
                        >
                            {depmts.map((dep, index) => (
                                <MenuItem key={index} value={dep._id}>
                                    <Typography>{dep.libelle}</Typography> 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <TextField
                size="small"
                label="Rechercher une dépense ou un don par libellé ou montant"
                disabled={!journal?.length>0}
                sx={{width:'60%', minWidth:'300px', marginTop:'10px'}}
                value={search_input}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                        <Search />
                        </InputAdornment>
                    ),
                }}
                onChange={(event)=> setSearch(event.target.value)}
                />
                
                {journal && !loading && <SorTable data={journal.filter(row=> row.compte===depmt && normalize(get_searchable(row)).includes(normalize(search_input)))} table={table.concat([editCol])} rowsPerPage={50} rowsPerPageOptions={[10, 25, 50, 100, 300]}/>}
            </Box>

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>
            <Dialog open={showPdf} onClose={()=>setShow(false)} fullWidth>
                <DialogContent>
                    {pdf && <embed src={pdf} width='100%' height='400px' type="application/pdf" />}
                </DialogContent>
            </Dialog>
        </div>
    )
}